import React from "react";
import { Game, Ownership, Player } from "../../types/types";
import { Tooltip, Paper, useTheme } from "@mui/material";
import styled from "@emotion/styled";
import { TOOLTIPS } from "../../globals/Globals";
import OwnershipTooltip from "../Tooltips/OwnershipTooltip";
import OwnershipTooltipPopover from "../Tooltips/OwnershipTooltipPopover";
import { CURRENT_SEASON } from "../../globals/BBLData";

const MyStatHeader = styled(Paper)`
  display: flex;
  width: 100%;
  margin-bottom: 12px;
  padding: 12px;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin-top: -2rem;
`;

const SecondStatHeader = styled(Paper)`
  display: flex;
  width: 100%;
  margin-bottom: 12px;
  padding: 12px;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;

const StatRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 800px) {
    b {
      width: 100%;
      margin-bottom: 0.5rem;
    }
  }
`;

const Mystatcontainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1rem;
  @media (min-width: 800px) {
    width: 15%;
    margin-bottom: 0;
  }
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: bold;
  @media (min-width: 800px) {
    flex-direction: row;
  }
`;

const HideForSmall = styled.div`
  @media (max-width: 800px) {
    display: none;
  }
`;

const StatsHeaderText = styled.div`
  text-align: center;
  text-decoration: underline;
  font-size: 0.75rem;
  @media (min-width: 800px) {
    font-size: 0.75rem;
  }
`;
const StatValueText = styled.div`
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  @media (min-width: 800px) {
    font-size: 0.8rem;
  }
`;

const StatRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;

const SecondStatContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 0.5rem;
  @media (max-width: 800px) {
    flex-direction: column;
    row-gap: 0.5rem;
  }
`;

export interface Props {
  stats: {
    last5: number[];
    lastgame: Game;
    price: number;
    price_change: number;
    season: string;
  }[];
  player: Player;
  games: Game[];
}

function StatsHeadline({ stats, player, games }: Props) {
  let thestat = null;
  let oldstat = null;
  let newseasonstat = null;

  stats.map(function (stat) {
    if (stat.season === "2023-24") {
      thestat = stat;
    } else if (stat.season === CURRENT_SEASON) {
      newseasonstat = stat;
    } else {
      oldstat = stat;
    }
  });
  console.log("The stat: ", { thestat, newseasonstat, stats });
  const theme = useTheme();
  const statslist = [];
  const lastgame = newseasonstat ? newseasonstat["lastgame"] : null;
  if (!lastgame) {
    return <></>;
  }

  let formattedPrice =
    newseasonstat?.price?.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    }) ?? "";
  formattedPrice = formattedPrice.substr(0, formattedPrice.length - 3);
  let price_change = newseasonstat?.price_change;
  let scavg = (
    newseasonstat.lastSeasonTotalPoints / newseasonstat.lastSeasonTotalGames
  )?.toFixed(2);

  //statslist.push({label: 'Price', value: lastgame.price})
  statslist.push({ label: "SC AVG (BBL13)", value: scavg });
  // statslist.push({
  //   label: "Overall Rank",
  //   value: newseasonstat.overallPointsRank,
  // });

  statslist.push({ label: "BE", value: lastgame.scbe });

  let bwlStatList = [
    { label: "AVG ECO", value: newseasonstat?.lastSeasonECOAVG.toFixed(2) },
    { label: "Wickets", value: newseasonstat?.lastSeasonTotalWickets },
    { label: "BWL Avg", value: newseasonstat?.lastSeasonAVGBWL.toFixed(2) },
  ];

  let batStatList = [
    { label: "SR", value: player.batStrikeStat?.avgSR },
    { label: "20+", value: newseasonstat?.twentyPlus },
    { label: "AVG Runs", value: newseasonstat?.lastSeasonAVGRuns?.toFixed(2) },
  ];

  const renderOwnershipStat = (ownership: Ownership) => {
    return (
      <Tooltip
        title={<OwnershipTooltipPopover ownership={ownership} />}
        placement="top"
        classes={{
          popper:
            theme.palette.mode === "dark"
              ? "myPopperClass-dark"
              : "myPopperClass-light",
        }}
      >
        <Mystatcontainer>
          <StatsHeaderText>Own</StatsHeaderText>
          <StatValueText>
            {player.lastownership
              ? player.lastownership.top10000
              : lastgame?.ownPerc
              ? lastgame?.ownPerc.toFixed(0)
              : ""}
            %
          </StatValueText>
        </Mystatcontainer>
      </Tooltip>
    );
  };
  const renderStat = (label: string, value: number | string) => {
    return (
      <Tooltip title={TOOLTIPS[label]} placement="top">
        <Mystatcontainer>
          <StatsHeaderText>{label}</StatsHeaderText>
          <StatValueText>{value}</StatValueText>
        </Mystatcontainer>
      </Tooltip>
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", rowGap: "0.5rem" }}>
      <MyStatHeader>
        <StatRow>
          <Tooltip title={TOOLTIPS["Price"]} placement="top">
            <Mystatcontainer>
              <StatsHeaderText>Price</StatsHeaderText>
              <PriceContainer
                style={{ color: price_change > -1 ? "green" : "red" }}
              >
                <span>{formattedPrice}</span>&nbsp;
                {/* Hiding for preseason */}
                {/* <span>
                  ({price_change > -1 ? "+" : ""}
                  {price_change?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                  )
                </span> */}
              </PriceContainer>
            </Mystatcontainer>
          </Tooltip>

          {statslist.map(function (stat) {
            return renderStat(stat.label, stat.value);
          })}
          {renderOwnershipStat(player.lastownership)}
        </StatRow>
      </MyStatHeader>
      <SecondStatContainer>
        <SecondStatHeader>
          <StatRow>
            <b>Bowling (BBL13)</b>

            {bwlStatList.map(function (stat) {
              return renderStat(stat.label, stat.value);
            })}
          </StatRow>
        </SecondStatHeader>
        <SecondStatHeader>
          <StatRow>
            <b>Batting (BBL13)</b>
            {batStatList.map(function (stat) {
              return renderStat(stat.label, stat.value);
            })}
          </StatRow>
        </SecondStatHeader>
      </SecondStatContainer>
    </div>
  );
}

export default StatsHeadline;
